import { render, staticRenderFns } from "./LicensePlateSearch.vue?vue&type=template&id=b99c0068&scoped=true&"
import script from "./LicensePlateSearch.vue?vue&type=script&lang=js&"
export * from "./LicensePlateSearch.vue?vue&type=script&lang=js&"
import style0 from "./LicensePlateSearch.vue?vue&type=style&index=0&id=b99c0068&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b99c0068",
  null
  
)

export default component.exports